module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAABCAYAAADuHp8EAAAAGUlEQVQImWP8////QwYIkIfSMIBbnIGBAQD5QgXggceniAAAAABJRU5ErkJggg=="